import {
  Box,
  TableCell,
  Card,
  Typography,
  Divider,
  Button,
} from "@material-ui/core";
import ActionDetailButton from "src/components/ActionButton";
import DataTable from "../../../../../components/DataTable";

export default function TngTransactionReportTableComponent({
  data,
  totalRow,
  handleChangePage,
  handleChangeRowsPerPage,
  tableFilter,
  isFetching,
  setSelected,
  handleExport,
}) {
  const canExport = !isFetching && Array.isArray(data) && data.length > 0;

  return (
    <Card sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" fontWeight="bold" mb={1}>
        Daily Disbursement Summary
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <DataTable
        isLoading={isFetching}
        rows={data}
        rowsPerPage={tableFilter.rowsPerPage}
        total={totalRow}
        page={tableFilter.page}
        renderHeader={() => (
          <>
            <TableCell>Date</TableCell>
            <TableCell>Total Disbursed(RM)</TableCell>
            <TableCell>Total Trx</TableCell>
            <TableCell>Integrity Check</TableCell>
            <TableCell>Reported Amount(RM)</TableCell>
            <TableCell>Reported Trx</TableCell>
            <TableCell>Discrepancy</TableCell>
            <TableCell>Action</TableCell>
          </>
        )}
        renderRow={(row, index) => {
          const actionItems = [
            {
              label: "View Details",
              action: () => {
                setSelected({
                  date: row.id,
                  type: "date",
                });
              },
            },
            {
              label: "Download CSV",
              action: () => {
                const link = document.createElement("a");
                link.href = row.url;
                link.download = row.filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              },
            },
          ];

          return (
            <>
              <TableCell align="left">{row.date}</TableCell>
              <TableCell align="left">{row.totalAmount}</TableCell>
              <TableCell align="left">
                {row.transactionInitializedCount}
              </TableCell>
              <TableCell align="left">
                <Box
                  color={
                    {
                      Pass: "green",
                      Failed: "red",
                    }[row.status] ?? "orange"
                  }
                >
                  {row.status}
                </Box>
              </TableCell>
              <TableCell align="left">{row.csvAmount}</TableCell>
              <TableCell align="left">
                {row.transactionCompletedCount}
              </TableCell>
              <TableCell align="left">
                {row.status === "Pass" ? (
                  "-"
                ) : row.status === "N/A" ? (
                  "N/A"
                ) : row.status === "Failed" ? (
                  <Box color="red">{row.discrepancy}</Box>
                ) : (
                  "N/A"
                )}
              </TableCell>
              <TableCell align="center">
                <ActionDetailButton
                  actionItems={actionItems}
                  popperStyle={{ zIndex: 999 }}
                />
              </TableCell>
            </>
          );
        }}
        onPageClick={handleChangePage}
        handleItemPerPageChange={handleChangeRowsPerPage}
      />
      {/*  )} */}
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        gap={2}
        mb={3}
        mt={3}
        flexWrap="wrap"
      >
        <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            Export as:
          </Typography>
          <Button
            variant="contained"
            color="primary"
            disabled={!canExport}
            onClick={() => handleExport?.("csv")}
          >
            CSV
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!canExport}
            onClick={() => handleExport?.("xlsx")}
          >
            EXCEL
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!canExport}
            onClick={() => handleExport?.("txt")}
          >
            TXT
          </Button>
        </Box>
      </Box>
    </Card>
  );
}
